import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyAIStalls from './components/WhyAIStalls';
import Services from './components/Services';
import Purpose from './components/Purpose';
import Product from './components/Product';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import About from './pages/About';
import Trust from './pages/Trust';
import ContactPage from './pages/ContactPage';
import OpsPage from './pages/systems/OpsPage';
import AdvisePage from './pages/systems/AdvisePage';
import VoicePage from './pages/systems/VoicePage';
import HirePage from './pages/systems/HirePage';
import DocsPage from './pages/systems/DocsPage';
import './App.css';

const HomePage: React.FC<{ isChatAvailable: boolean; isChatOpen: boolean; setIsChatOpen: (v: boolean) => void }> = ({
  isChatAvailable,
  isChatOpen,
  setIsChatOpen,
}) => {
  const chatWidgetUrl = 'https://api.zwiftlabs.com/static/widget.html';
  return (
    <>
      <main>
        <Hero />
        <WhyAIStalls />
        <Services />
        <Purpose />
        <Product />
        <Testimonials />
        <FAQ />
        <CTABanner />
        <Contact />
      </main>

      {isChatAvailable && (
        <div className="fixed bottom-20 right-6 z-50 flex flex-col items-end">
          {isChatOpen && (
            <div className="mb-1 animate-slide-up">
              <iframe
                src={chatWidgetUrl}
                title="Zwift Labs Assistant"
                style={{
                  width: '400px',
                  height: '650px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '10px',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                }}
                allow="clipboard-read; clipboard-write"
              />
            </div>
          )}
          <button
            onClick={() => setIsChatOpen(!isChatOpen)}
            className="bg-black hover:bg-neutral-800 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300"
            aria-label={isChatOpen ? 'Close chat' : 'Open chat'}
          >
            {isChatOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            )}
          </button>
        </div>
      )}
    </>
  );
};

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isChatAvailable, setIsChatAvailable] = useState(false);
  const chatWidgetUrl = 'https://api.zwiftlabs.com/static/widget.html';

  useEffect(() => {
    const checkChatAvailability = async () => {
      try {
        const response = await fetch(chatWidgetUrl, { method: 'HEAD' });
        if (response.ok) {
          setIsChatAvailable(true);
        }
      } catch (error) {
        setIsChatAvailable(false);
      }
    };
    checkChatAvailability();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <HomePage
                isChatAvailable={isChatAvailable}
                isChatOpen={isChatOpen}
                setIsChatOpen={setIsChatOpen}
              />
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/trust" element={<Trust />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/systems/ops" element={<OpsPage />} />
          <Route path="/systems/advise" element={<AdvisePage />} />
          <Route path="/systems/voice" element={<VoicePage />} />
          <Route path="/systems/hire" element={<HirePage />} />
          <Route path="/systems/docs" element={<DocsPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
